// 组织结构
import { Layout } from '@/utils/routerHelper'

const refereeMgtRouter = {
  path: '/referee-mgt',
  component: Layout,
  alwaysShow: true, // will always show the root menu
  name: 'M_REFEREE_MGT',
  // code: 'M_REFEREE_MGT',
  meta: {
    // title: '裁判员管理',
    // icon: 'clarity:user-line'
  },
  children: [
    {
      path: 'referee-list',
      component: () => import('@/views/referee-mgt/index.vue'),
      // name: '裁判员列表',
      // code: 'M_REFEREE_LIST',
      name: 'M_REFEREE_LIST',
      meta: {
        title: '裁判员',
        icon: 'ep:user-filled',
      }
    }
  ]
}

export default refereeMgtRouter
